define('modules/base/models/base.paging.model',[
    'underscore',
    'backbone',
    'modules/base/models/base.model'
], function(_, Backbone, BaseModel){
    var BasePagingModel = BaseModel.extend({
        page: 1,
        pageSize: 10,
        url:function(){
            var needsQuestion = true;
            var needsAnd = false;
            var url = 'prospector/v1/' + this.base;
            if(this.has('id')){
                url += '/' + this.get('id');
                var idParams = this.extendedIDParams();
                if(idParams != ''){
                    url += '?'+ this.extendedIDParams()
                    needsQuestion = false;
                    needsAnd = true;
                }
            }
            if(needsQuestion){
                url += '?';
            }
            if(needsAnd){
                url += '&';
            }
            url += 'page=' + this.page + '&pageSize=' + this.pageSize + this.extendedParams();
            return window.utils.makeUrl(url);
        },
        extendedParams:function(){
            return '';
        },
        extendedIDParams:function(){
            return '';
        }
    });
    return BasePagingModel;
});



